(function () {
    'use strict';

    function initSearchSwiper(container) {
        if (typeof Swiper === 'undefined') return;
        var els = container.querySelectorAll('.mtrx-search-swiper');
        els.forEach(function (el) {
            if (el.swiper) {
                el.swiper.destroy(true, true);
            }
            new Swiper(el, {
                slidesPerView: 2.2,
                spaceBetween: 12,
                observer: true,
                observeParents: true,
                navigation: {
                    nextEl: el.querySelector('.mtrx-search-swiper__next'),
                    prevEl: el.querySelector('.mtrx-search-swiper__prev')
                },
                breakpoints: {
                    768: { slidesPerView: 3, spaceBetween: 16 },
                    1024: { slidesPerView: 4, spaceBetween: 16 }
                }
            });

            // Make swiper container focusable.
            // predictive-search.js closes results when focus leaves <predictive-search>.
            // Clicking non-focusable Swiper elements moves focus to body → triggers close().
            // tabindex="-1" makes the swiper a valid focus target: clicking anywhere inside it
            // gives it focus, which is still inside <predictive-search> → no close().
            el.setAttribute('tabindex', '-1');
            var prev = el.querySelector('.mtrx-search-swiper__prev');
            var next = el.querySelector('.mtrx-search-swiper__next');
            if (prev) prev.setAttribute('tabindex', '-1');
            if (next) next.setAttribute('tabindex', '-1');
        });
    }

    function initWhenVisible(container) {
        setTimeout(function () {
            initSearchSwiper(container);
            setTimeout(function () {
                container.querySelectorAll('.mtrx-search-swiper').forEach(function (el) {
                    if (el.swiper) el.swiper.update();
                });
                attachScrollHint(container);
            }, 350);
        }, 60);
    }

    // ── Scroll hint ────────────────────────────────────────────────

    function attachScrollHint(resultsContainer) {
        var scroller = findScrollContainer(resultsContainer);
        if (!scroller) return;

        var existing = scroller.querySelector('.mtrx-scroll-hint');
        if (existing) existing.remove();

        if (scroller.scrollHeight <= scroller.clientHeight + 10) return;

        var hint = document.createElement('div');
        hint.className = 'mtrx-scroll-hint';
        hint.setAttribute('aria-hidden', 'true');
        hint.innerHTML =
            '<svg width="18" height="18" viewBox="0 0 18 18" fill="none">' +
            '<polyline points="3,6 9,12 15,6" stroke="currentColor" stroke-width="2" ' +
            'stroke-linecap="round" stroke-linejoin="round"/>' +
            '</svg>';

        scroller.appendChild(hint);

        function onScroll() {
            var atBottom = scroller.scrollTop + scroller.clientHeight >= scroller.scrollHeight - 20;
            if (atBottom) {
                hint.classList.add('mtrx-scroll-hint--gone');
                scroller.removeEventListener('scroll', onScroll);
            }
        }
        scroller.addEventListener('scroll', onScroll, { passive: true });
    }

    function findScrollContainer(el) {
        var node = el;
        while (node && node !== document.body) {
            var overflow = window.getComputedStyle(node).overflowY;
            if ((overflow === 'auto' || overflow === 'scroll') && node.scrollHeight > node.clientHeight + 4) {
                return node;
            }
            node = node.parentElement;
        }
        return null;
    }

    // ── Global capture: keep focus inside search when clicking results ─────────
    // Runs in capture phase (before Swiper or any bubble listeners).
    // Prevents mousedown from stealing focus away from the search input
    // for non-interactive elements (Swiper wrapper, slide container etc.).
    // click events still fire so links and buttons work normally.
    document.addEventListener('mousedown', function (e) {
        if (!e.target.closest('[data-predictive-search]')) return;
        // Don't intercept clicks on naturally focusable elements
        if (e.target.closest('a[href], button, input, select, textarea, [tabindex]')) return;
        e.preventDefault();
    }, { capture: true, passive: false });

    // ── Observers ──────────────────────────────────────────────────

    var trendingEl = document.querySelector('[data-quick-trending-products]');
    if (trendingEl) {
        var classObs = new MutationObserver(function (mutations) {
            mutations.forEach(function (m) {
                if (m.attributeName === 'class' && !trendingEl.classList.contains('hidden')) {
                    initWhenVisible(trendingEl);
                }
            });
        });
        classObs.observe(trendingEl, { attributes: true, attributeFilter: ['class'] });
    }

    document.querySelectorAll('[data-predictive-search]').forEach(function (predictiveEl) {
        var obs = new MutationObserver(function () {
            initWhenVisible(predictiveEl);
        });
        obs.observe(predictiveEl, { childList: true });
    });
})();
